import { PettyCashDetailPage } from '@/features/petty-cash/pages/PettyCashDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/petty-cash/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: () => <PettyCashDetailPage/>,
})
